<template>
  <div id="">
    <c-block-box title="酷开9数据概览" class="first-floor-item-1">
      <div class="first-item-content">
        <div class="first-item-1">
          <CoolSmallCard></CoolSmallCard>
        </div>
        <div class="first-chart-wrap">
          <div class="first-chart1">
            <DomeEchartWrap ref="first-chart1" id="first-chart1"></DomeEchartWrap>
          </div>
          <div class="first-chart2">
            <div class="first-chart-title">
              各系统7日留存率与30日留存率
            </div>
            <DomeEchartWrap ref="first-chart2" id="first-chart2"></DomeEchartWrap>
          </div>
          <div class="first-chart3">
            <div class="first-chart-title">
              各系统7日留存率与30日留存率
            </div>
            <div class="chart3-content">
              <div class="legend-warp">
                <div class="item" v-for="(item,index) in InventoryTypeDistributionLists">
                  <span class="icon" :class="[`icon-${index + 1}`]"></span>
                  <span class="name">{{ item.name }}</span>
                  <span class="rate">{{ item.rate }}%</span>
                </div>
              </div>
              <div class="chart3-wrap">
                <DomeEchartWrap ref="first-chart3" id="first-chart3"></DomeEchartWrap>
              </div>
            </div>
          </div>
          <div class="first-chart4">
            <div class="first-chart-title">
              各系统7日留存率与30日留存率
            </div>
            <DomeEchartWrap ref="first-chart4" id="first-chart4"></DomeEchartWrap>
          </div>
          <div class="first-chart5">
            <div class="first-chart-title">
              各系统7日留存率与30日留存率
            </div>
            <DomeEchartWrap ref="first-chart5" id="first-chart5"></DomeEchartWrap>
          </div>
        </div>
      </div>
    </c-block-box>
  </div>
</template>

<script>
import CoolSmallCard from './CoolSmallCard.vue'
import { firstchart1EchartOp, firstchart2EchartOp, firstchart3EchartOp, firstchart4EchartOp, firstchart5EchartOp } from './js/FirstFloor'
import DomeEchartWrap from '@/components/echarts/DomeEchartWrap'
import common from '@/mixins/common.js'

export default {
  mixins: [common],
  name: '',
  components: {
    CoolSmallCard,
    DomeEchartWrap
  },
  props: [],
  data () {
    return {
      InventoryTypeDistributionLists: [
        {
          name: 'A',
          count: '2',
          rate: 40
        }
      ]
    }
  },
  computed: {},
  created () {},
  mounted () {
    this.$refs['first-chart1'].setEchartOption(firstchart1EchartOp({ v: this }))
    this.$refs['first-chart2'].setEchartOption(firstchart2EchartOp({ v: this }))
    this.$refs['first-chart3'].setEchartOption(firstchart3EchartOp({ v: this }))
    this.$refs['first-chart4'].setEchartOption(firstchart4EchartOp({ v: this }))
    this.$refs['first-chart5'].setEchartOption(firstchart5EchartOp({ v: this }))
  },
  watch: {},
  methods: {}
}
</script>

<style scoped lang="stylus">
.first-item-content {
  padding: 20px;
  display: flex;
  height 250px
}
.first-chart-wrap
  display: flex
  flex-wrap: wrap
  justify-content: space-around
  margin-left: 30px
  flex-grow: 1
  height 100%
  overflow: hidden
.first-chart1,.first-chart3,.first-chart4,.first-chart5,.first-chart2
  width 325px
  display: flex
  flex-direction column
  overflow hidden

#first-chart2,#first-chart4
  flex-grow 1

.chart3-content
  display: flex
  flex-grow: 1
  .chart3-wrap
    flex-grow: 1
    height: 100%
.first-chart-title
  color: rgba(255, 255, 255, 0.8)
  font-size: 16px
  margin-bottom: 10px

.legend-warp
    width 130px
    margin-right: 20px
    flex-shrink: 0
    .item
      display: flex
      align-items: center
      padding: 12px 0
      border-bottom: 0.05rem solid rgba(255, 255, 255, 0.1);
      span.name
        color rgba(255, 255, 255, 0.8)
      span.rate
        margin-left: auto;
        font-size:20px
        color: rgba(255, 255, 255, 1)
      > span
          display inline-block
          font-size: 12px
      .icon
        width: 10px;
        height: 10px;
        border-radius: 1px;
        margin-right 5px
      .icon-1
        background: linear-gradient(45deg, #025EE2 0%, #29BAFF 100%);
      .icon-2
        background: linear-gradient(225deg, #B945F5 0%, #565BFE 100%);
      .icon-3
        background: linear-gradient(45deg, #FF33CB 0%, #FA7481 100%);
      .icon-4
        background: linear-gradient(45deg, #37B4EE 0%, #3AF1C3 100%);
      .icon-5
        background: linear-gradient(225deg, #D2ED1B 0%, #86F61D 100%);
</style>
